export default __webpack_public_path__ + "static/media/workinghours.8a8c0156.svg";